import { Component, OnInit } from '@angular/core';
import {  ParametroVars } from 'src/app/general/variables';
import { ParametroService } from 'src/app/services/parametro.service';

@Component({
  selector: 'app-footer-principal',
  templateUrl: './footer-principal.component.html',
  styleUrls: ['./footer-principal.component.css']
})
export class FooterPrincipalComponent implements OnInit {

  strDscTelefCGR = '';

  constructor(protected parametroService: ParametroService, ) { }

  ngOnInit() {

    this.strDscTelefCGR = ParametroVars.Param35;

  }

}
